
































    import chunk from 'lodash/chunk';
    import moment from 'moment';
    import { Component, Prop } from 'vue-property-decorator';
    import { State } from 'vuex-class';
    import { formatter } from '../app.config';
    import Calculator from '../helpers/calculator';
    import { IFlight, ITour } from '../store/models';
    import BaseComponent from './Base';

    interface DisplayablePrices {
    price: string;

    date: string;

    monthYear: string;
}

    @Component
export default class TourPricesTable extends BaseComponent {
    @Prop({ type: Number }) protected readonly sid: ITour['sid'];

    @State('flights', { namespace: 'orm' }) protected readonly storedFlights: IFlight[];

    protected get flight(): IFlight | null {
        return this.storedFlights.find(({ tourSid }) => tourSid === this.sid) || null;
    }

    protected get packagePrices(): DisplayablePrices[] {
        const flight = this.flight;
        if (!flight) {
            return [];
        }
        const currentMonth: moment.Moment = moment().startOf('month');
        const parsedPrices: DisplayablePrices[] = [];

        /**
         * Dates must be in a YYYY-MM-DD format
         */
        flight.prices.forEach(({ adultPrice, date }) => {
            // Do not show sold outs
            if (Calculator.isSoldOut(adultPrice)) {
                return;
            }
            const d = moment(date, 'YYYY-MM-DD');
            // Do not show prices in past
            if (currentMonth.isAfter(d)) {
                return;
            }
            parsedPrices.push({
                price: formatter.asCurrency(adultPrice),
                date: d.format('YYYY-MM-DD'),
                monthYear: d.format('YYYY-MM'),
            });
        });

        return parsedPrices;
    }

    protected get monthsChunk(): string[][] {
        const map = {};
        this.packagePrices.forEach(({ monthYear }) => map[monthYear] = monthYear);
        return chunk<string>(Object.values(map), 2);
    }

    /**
     * List of week days names in current locale starting from monday.
     */
    protected get weekdays(): string[] {
        return Array(7).fill(1).map((n, i) => moment().day(n + i).format('ddd'));
    }

    protected getDay(date: string): string {
        return moment(date).format('D');
    }

    protected getMonth(date: string): string {
        return moment(date, 'YYYY-MM').format('MMMM YYYY');
    }

    protected isInMonth(date: string, monthYear: string): boolean {
        return moment(monthYear, 'YYYY-MM').isSame(moment(date), 'month');
    }

    protected outputPriceFor(date: string): string {
        const pack: DisplayablePrices | undefined = this.packagePrices.find((p) => p.date === date);
        if (!pack) {
            return ``;
        }
        return `<span class="c-calendar-table__price">${ pack.price }</span>`;
    }

    protected listDaysOfMonth(monthYear: string): string[][] {
        const startDate = moment(monthYear, 'YYYY-MM').startOf('month').startOf('day');
        const endDate = startDate.clone().endOf('month').startOf('day');
        const calendar: string[][] = [];

        for (const currentDate = startDate.clone(); currentDate.isSameOrBefore(endDate); currentDate.add(1, 'week').startOf('week')) {
            calendar.push(Array(7).fill(0).map((n, i) => currentDate.clone().startOf('week').add(n + i, 'day').format('YYYY-MM-DD')));
        }

        return calendar;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TourPricesTable.vue